import { useTranslation } from '../../../../../i18n/hooks/useTranslation';

export default function VoterRegistrationFormInfoBox() {
    const { t } = useTranslation();
    const docs = t('voterRegistrationForm.infoBox.docs', { returnObjects: true });

    return (
        <div className="mt-2 rounded-[10px] border border-cyan-300 bg-cyan-50 px-5 py-5 dark:border-cyan-900/50 dark:bg-cyan-950/20">
            <h3 className="mb-3 text-[15px] font-bold text-cyan-800 dark:text-cyan-300">
                {t('voterRegistrationForm.infoBox.title')}
            </h3>

            <div className="mb-4 h-px bg-cyan-200 dark:bg-cyan-900/40" />

            <p className="mb-2 text-[13px] font-semibold text-[#1C1815] dark:text-zinc-200">
                {t('voterRegistrationForm.infoBox.docsTitle')}
            </p>

            <ul className="mb-4 list-disc space-y-1.5 pl-5 text-[13px] leading-relaxed text-[#1C1815] dark:text-zinc-300">
                {Array.isArray(docs) && docs.map((item) => (
                    <li key={item}>{item}</li>
                ))}
            </ul>

            <p className="mb-3 text-[13px] font-medium leading-relaxed text-red-700 dark:text-red-400">
                {t('voterRegistrationForm.infoBox.accuracyWarning')}
            </p>

            <p className="text-[13px] font-medium leading-relaxed text-orange-800 dark:text-orange-400">
                {t('voterRegistrationForm.infoBox.submitWarning')}
            </p>
        </div>
    );
}
